// 画像圧縮しないサイズ１MB
export const IMAGE_COMPRESS_SIZE = 1024 * 1024
